<template>
    <default needs-project>
        <div id="dashboard_main">
            <pre>
                {{ project }}
            </pre>
        </div>
    </default>
</template>

<script>
  import Default from '../components/layouts/Default'
  export default {
    name: 'Dashboard',
    components: { Default },
    computed:{
      project(){
        return this.$store.getters['Projects/get_project']
      }
    }
  }
</script>

<style scoped>
    #dashboard_main{

    }
</style>
